import React from 'react'

import { observer } from 'mobx-react-lite'

import { Badge } from 'ziphy-web-shared/basic/lib/simple'

import { $booking } from '@store'

import styles from './SelectedSymptoms.module.scss'

const SelectedSymptoms = () => {
  return (
    $booking.$symptoms.combinedSelectedSymptomsIds.length > 0 && (
      <div className={styles.badges}>
        {$booking.$symptoms.combinedSelectedSymptomsIds.map((symptomId, index) => (
          <Badge
            key={index}
            mode={['primary', 'sm', 'outline', 'minHeight32']}
            onClose={() => $booking.$symptoms.REMOVE_SELECTED(symptomId)}
          >
            {$booking.$symptoms.getSymptomName(symptomId)}
          </Badge>
        ))}
      </div>
    )
  )
}

export default observer(SelectedSymptoms)
